import { menuController } from '@ionic/core/components';
import { DrawerState } from '../components/DrawerState';

export class CareMapDrawerHelper {
    static inject = () => [DrawerState];
    constructor(private drawerState: DrawerState) {}

    open = () => {
        this.drawerState.openMenu();
    };

    close = () => {
        menuController.close();
    };

    closeAndExecute = (fn: () => void) => {
        this.close();
        setTimeout(fn, 350);
    };
};
